/**
 * Compact relative-time formatter for UI surfaces.
 * Produces short tokens like "5m", "3h", "2d", "4w", "6mo", "1y".
 * Falls back to a locale date string for invalid input.
 */
export function formatRelativeShort(
  input: string | number | Date,
  now: Date = new Date()
): string {
  const date = input instanceof Date ? input : new Date(input);
  if (Number.isNaN(date.getTime())) return "";

  const diffMs = now.getTime() - date.getTime();
  const future = diffMs < 0;
  const absMs = Math.abs(diffMs);

  const minute = 60 * 1000;
  const hour = 60 * minute;
  const day = 24 * hour;
  const week = 7 * day;
  const month = 30 * day;
  const year = 365 * day;

  let value: number;
  let unit: string;

  if (absMs < minute) return "now";
  if (absMs < hour) {
    value = Math.floor(absMs / minute);
    unit = "m";
  } else if (absMs < day) {
    value = Math.floor(absMs / hour);
    unit = "h";
  } else if (absMs < week) {
    value = Math.floor(absMs / day);
    unit = "d";
  } else if (absMs < month) {
    value = Math.floor(absMs / week);
    unit = "w";
  } else if (absMs < year) {
    value = Math.floor(absMs / month);
    unit = "mo";
  } else {
    value = Math.floor(absMs / year);
    unit = "y";
  }

  return future ? `in ${value}${unit}` : `${value}${unit}`;
}
